import $ from 'jquery';

let preventBodyScrollOnMenuClick = () => {
  $("#menu-link, #project-link").on('click', () => {
    document.getElementsByTagName('body')[0].classList.add('prevent-scroll');
    document.getElementsByTagName('html')[0].classList.add('prevent-scroll');
  })
}

let activateScrollOnCancelClick = () => {
  $("#cancel-menu-1, #contact-close-2").on('click', () => {
    document.getElementsByTagName('body')[0].classList.remove('prevent-scroll');
    document.getElementsByTagName('html')[0].classList.remove('prevent-scroll');
  })
}

preventBodyScrollOnMenuClick();
activateScrollOnCancelClick();
